"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = require("react");

var _methods = require("../utils/methods");

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var _default = function _default(_ref) {
  var columnSections = _ref.columnSections,
      columnQuantity = _ref.columnQuantity,
      startDatetime = _ref.startDatetime,
      columnRangeType = _ref.columnRangeType;

  var _useState = (0, _react.useState)(0),
      _useState2 = _slicedToArray(_useState, 2),
      totalTimeRow = _useState2[0],
      setTotalTimeRow = _useState2[1];

  var _useState3 = (0, _react.useState)(0),
      _useState4 = _slicedToArray(_useState3, 2),
      dayWidth = _useState4[0],
      setDayWidth = _useState4[1];

  var _useState5 = (0, _react.useState)(0),
      _useState6 = _slicedToArray(_useState5, 2),
      hourWidth = _useState6[0],
      setHourWidth = _useState6[1];

  var _useState7 = (0, _react.useState)(0),
      _useState8 = _slicedToArray(_useState7, 2),
      minuteWidth = _useState8[0],
      setMinuteWidth = _useState8[1];

  var _useState9 = (0, _react.useState)(0),
      _useState10 = _slicedToArray(_useState9, 2),
      secondWidth = _useState10[0],
      setSecondWidth = _useState10[1];

  var calcWidthTimeDay = (0, _react.useCallback)(function () {
    var rangeTime = (0, _methods.addDays)(startDatetime, columnQuantity) - startDatetime;
    var rangeTimeSeconds = rangeTime / 1000;
    var dayTime = rangeTimeSeconds / columnQuantity;
    var hourTime = dayTime / (columnSections + 1);
    setTotalTimeRow(rangeTimeSeconds);
    setDayWidth(dayTime);
    setHourWidth(hourTime);
    setMinuteWidth(hourTime / 60);
  }, [startDatetime, columnSections, columnQuantity]);
  var calcWidthTimeHour = (0, _react.useCallback)(function () {
    var rangeTime = (0, _methods.addHours)(startDatetime, columnQuantity) - startDatetime;
    var rangeTimeSeconds = rangeTime / 1000;
    var hourTime = rangeTimeSeconds / columnQuantity;
    var minuteTime = hourTime / (columnSections + 1);
    setTotalTimeRow(rangeTimeSeconds);
    setHourWidth(hourTime);
    setMinuteWidth(minuteTime);
    setSecondWidth(minuteTime / 60);
  }, [columnQuantity, columnSections, startDatetime]);
  var calcTotalTime = (0, _react.useCallback)(function (value) {
    var _secondsToDhms = (0, _methods.secondsToDhms)(value),
        days = _secondsToDhms.days,
        hours = _secondsToDhms.hours,
        minutes = _secondsToDhms.minutes,
        seconds = _secondsToDhms.seconds;

    var totalDaysVal = dayWidth * days;
    var totalHoursVal = hourWidth * hours;
    var totalMinutesVal = minuteWidth * minutes;
    var totalSecondsVal = secondWidth * seconds;
    return totalDaysVal + totalHoursVal + totalMinutesVal + totalSecondsVal;
  }, [dayWidth, hourWidth, minuteWidth, secondWidth]);
  (0, _react.useEffect)(function () {
    switch (columnRangeType) {
      case 'DAY':
        calcWidthTimeDay();
        break;

      case 'HOUR':
        calcWidthTimeHour();
        break;

      default:
        calcWidthTimeDay();
        break;
    }
  }, [calcWidthTimeDay, calcWidthTimeHour, columnRangeType]);
  return {
    dayWidth: dayWidth,
    hourWidth: hourWidth,
    minuteWidth: minuteWidth,
    secondWidth: secondWidth,
    totalTimeRow: totalTimeRow,
    calcTotalTime: calcTotalTime
  };
};

exports["default"] = _default;